var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ais-refinement-list", {
    attrs: { attribute: _vm.attribute, operator: "or" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ items, refine }) {
          return [
            _c(
              "div",
              { staticClass: "d-flex flex-wrap flex-sm-nowrap" },
              [
                _c(
                  "ci-checkbox",
                  {
                    staticClass: "flex-shrink-0 mr-3 mb-3",
                    attrs: {
                      id: "article-8",
                      label: _vm.$t(
                        "ui.components.base.ais.sfdr_refinement_list.article_8.label"
                      ),
                      value: _vm.isRefined("article_8", items),
                      vCenter: true,
                      name: _vm.attribute + "_article_8",
                    },
                    on: {
                      change: function ($event) {
                        return refine("article_8")
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "mdi mdi-leaf mr-1 ml-2 text-primary",
                    }),
                    _c("div", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            customClass: "tooltip-xl text-left",
                            html: true,
                          },
                          expression:
                            "{ customClass: 'tooltip-xl text-left', html: true }",
                        },
                      ],
                      staticClass: "mdi mdi-information mx-1 text-muted",
                      attrs: {
                        title: _vm.$t(
                          "ui.components.base.ais.sfdr_refinement_list.article_8.description_html"
                        ),
                      },
                    }),
                  ]
                ),
                _c(
                  "ci-checkbox",
                  {
                    staticClass: "flex-shrink-0 mb-3",
                    attrs: {
                      id: "article-9",
                      label: _vm.$t(
                        "ui.components.base.ais.sfdr_refinement_list.article_9.label"
                      ),
                      value: _vm.isRefined("article_9", items),
                      vCenter: true,
                      name: _vm.attribute + "_article_9",
                    },
                    on: {
                      change: function ($event) {
                        return refine("article_9")
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "mdi mdi-leaf mr-1 ml-2 text-primary-700",
                    }),
                    _c("div", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            customClass: "tooltip-xl text-left",
                            html: true,
                          },
                          expression:
                            "{ customClass: 'tooltip-xl text-left', html: true }",
                        },
                      ],
                      staticClass: "mdi mdi-information mx-1 text-muted",
                      attrs: {
                        title: _vm.$t(
                          "ui.components.base.ais.sfdr_refinement_list.article_9.description_html"
                        ),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }